"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _withSiteTracking = require("./withSiteTracking");
var _withPageTracking = require("./withPageTracking");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function withEventTracking(Component, noContextInject) {
  return function WithEventTracking(props) {
    return _react["default"].createElement(_withSiteTracking.SiteContext.Consumer, null, function (data) {
      if (!data) {
        if (noContextInject) {
          return _react["default"].createElement(Component, _extends({}, props, noContextInject));
        }
        throw new Error("You should wrap your root level component with `withSiteTracking`.");
      }
      var siteData = data.siteData,
        _data$inject = data.inject,
        inject = _data$inject === void 0 ? {} : _data$inject;
      return _react["default"].createElement(_withPageTracking.PageContext.Consumer, null, function (pageData) {
        return _react["default"].createElement(Component, _extends({}, props, Object.keys(inject).reduce(function (acc, prop) {
          acc[prop] = function (eventData) {
            return inject[prop]({
              siteData: siteData,
              pageData: pageData,
              eventData: eventData
            });
          };
          return acc;
        }, {})));
      });
    });
  };
}
var _default = withEventTracking;
exports["default"] = _default;